import { render, staticRenderFns } from "./RecipeInstructions.vue?vue&type=template&id=3415300a"
import script from "./RecipeInstructions.vue?vue&type=script&lang=js"
export * from "./RecipeInstructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports